"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jssPluginRuleValueFunction = _interopRequireDefault(require("jss-plugin-rule-value-function"));

var _jssPluginRuleValueObservable = _interopRequireDefault(require("jss-plugin-rule-value-observable"));

var _jssPluginTemplate = _interopRequireDefault(require("jss-plugin-template"));

var _jssPluginGlobal = _interopRequireDefault(require("jss-plugin-global"));

var _jssPluginExtend = _interopRequireDefault(require("jss-plugin-extend"));

var _jssPluginNested = _interopRequireDefault(require("jss-plugin-nested"));

var _jssPluginCompose = _interopRequireDefault(require("jss-plugin-compose"));

var _jssPluginCamelCase = _interopRequireDefault(require("jss-plugin-camel-case"));

var _jssPluginDefaultUnit = _interopRequireDefault(require("jss-plugin-default-unit"));

var _jssPluginExpand = _interopRequireDefault(require("jss-plugin-expand"));

var _jssPluginVendorPrefixer = _interopRequireDefault(require("jss-plugin-vendor-prefixer"));

var _jssPluginPropsSort = _interopRequireDefault(require("jss-plugin-props-sort"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var index = function index(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    plugins: [(0, _jssPluginRuleValueFunction["default"])(), (0, _jssPluginRuleValueObservable["default"])(options.observable), (0, _jssPluginTemplate["default"])(), (0, _jssPluginGlobal["default"])(), (0, _jssPluginExtend["default"])(), (0, _jssPluginNested["default"])(), (0, _jssPluginCompose["default"])(), (0, _jssPluginCamelCase["default"])(), (0, _jssPluginDefaultUnit["default"])(options.defaultUnit), (0, _jssPluginExpand["default"])(), (0, _jssPluginVendorPrefixer["default"])(), (0, _jssPluginPropsSort["default"])()]
  };
};

var _default = index;
exports["default"] = _default;